var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWallet = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m12.5.182.021-.006a3.744 3.744 0 0 1 1.718-.13 3.737 3.737 0 0 1 3.136 3.355 3.803 3.803 0 0 1 2.458 3.553v3.267l.002.065v2.584c0 .022 0 .044-.002.066v3.266A3.803 3.803 0 0 1 16.035 20H3.798A3.803 3.803 0 0 1 0 16.202V6.954a3.803 3.803 0 0 1 3.177-3.746l4.96-1.61a.085.085 0 0 1 .029-.013l.073-.02.697-.227.544-.181c.98-.326 2.264-.753 2.99-.966l.03-.009Zm5.435 8.205h-4.08a1.901 1.901 0 0 0-1.898 1.899v2.584a1.902 1.902 0 0 0 1.898 1.9h4.08v1.436a1.9 1.9 0 0 1-1.9 1.9l-12.237-.005a1.901 1.901 0 0 1-1.9-1.9V6.955a1.901 1.901 0 0 1 1.9-1.9h12.237a1.901 1.901 0 0 1 1.9 1.9v1.433Zm-2.283-5.669c.07.14.127.287.167.438H8.176l4.785-1.554a2.241 2.241 0 0 1 2.69 1.116Zm2.283 7.568v2.584h-4.08v-2.584h4.08Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWallet);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wallet.2d6707c27f8f4ae07d0c3fb8cd061888.svg";